// utils.js
export const isTokenExpired = () => {
  const access_token = localStorage.getItem("access_token");
  const expires_at = localStorage.getItem("expires_at");
  if (!access_token || !expires_at) return true;

  return Date.now() > parseInt(expires_at, 10);
};
